module.exports = __webpack_public_path__ + "img/skin-redness.c16a22ca.svg";